// src/pages/SubjectResponsesPage.jsx
import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Button,
  Stack,
  Divider,
} from '@mui/material';
import { useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { fetchSubjectResponses } from '../controllers/subject.controller';
import { getFullFormResponse } from '../controllers/formResponse.controller';

const SubjectResponsesPage = () => {
  const { id } = useParams(); // id = subjectId
  const [subject, setSubject] = useState(null);
  const [responses, setResponses] = useState([]);
  const [selected, setSelected] = useState(null); // برای نمایش جزئیات
  const [structure, setStructure] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetchSubjectResponses(id);
        // انتظار داریم سرور برگردونه: { subject, responses: [...] }
        setSubject(res.subject);
        setResponses(res.responses || []);
      } catch (err) {
        console.error(err);
        toast.error('خطا در دریافت پاسخ‌های این بیمار');
      }
    };
    load();
  }, [id]);

  const handleView = async (responseRow) => {
    try {
      const { response, structure } = await getFullFormResponse(responseRow._id);
      setSelected(response);
      setStructure(structure || []);
    } catch (err) {
      console.error(err);
      toast.error('خطا در دریافت جزئیات پاسخ');
    }
  };

  return (
    <Box sx={{ p: 3 }} dir="rtl">
      <ToastContainer position="top-right" />

      <Typography variant="h5" mb={2}>
        📄 پاسخ‌های ثبت‌شده برای بیمار
      </Typography>
      {subject && (
        <Box mb={2}>
          <Typography>
            بیمار: <b>{subject.firstName} {subject.lastName}</b>
          </Typography>
          {subject.nationalId && <Typography>کد ملی: {subject.nationalId}</Typography>}
        </Box>
      )}

      <Paper>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>فرم</TableCell>
              <TableCell>کاربر ثبت‌کننده</TableCell>
              <TableCell>تاریخ ارسال</TableCell>
              <TableCell>وضعیت ارزیابی</TableCell>
              <TableCell>عملیات</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {responses.map((r) => (
              <TableRow key={r._id}>
                <TableCell>{r.formId?.title?.fa || r.formId?.title || '—'}</TableCell>
                <TableCell>{r.userId?.fullName || r.userId?.email || '—'}</TableCell>
                <TableCell>
                  {r.submittedAt
                    ? new Date(r.submittedAt).toLocaleString('fa-IR')
                    : '—'}
                </TableCell>
                <TableCell>
                  {{
                    accepted: '✅ تأیید شده',
                    rejected: '❌ رد شده',
                    pending: '⏳ در انتظار'
                  }[r.evaluation?.status] || '—'}
                </TableCell>
                <TableCell>
                  <Button variant="outlined" size="small" onClick={() => handleView(r)}>
                    مشاهده
                  </Button>
                </TableCell>
              </TableRow>
            ))}

            {responses.length === 0 && (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  هیچ پاسخی برای این بیمار ثبت نشده است.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Paper>

      {/* نمایش جزئیات پاسخ، شبیه ResponseEvaluationPage ولی ساده‌تر */}
      {selected && (
        <Box sx={{ mt: 4 }}>
          <Typography variant="h6" mb={2}>
            جزئیات پاسخ فرم: {selected.formId?.title?.fa || '—'}
          </Typography>
          <Divider sx={{ mb: 2 }} />

          {Array.isArray(structure) && structure.length > 0 ? (
            structure.map((field, idx) => {
              const ans = selected.answers?.find(a => a.fieldId === field.fieldId);
              const value = ans?.value;

              return (
                <Box key={idx} sx={{ mb: 2 }}>
                  <Typography fontWeight="bold">{field.titlep || 'بدون عنوان'}</Typography>
                  {/* فایل */}
                  {typeof value === 'string' && value.startsWith('file-') ? (
                    <a
                      href={`/uploads/${value}`}
                      target="_blank"
                      rel="noreferrer"
                      style={{ color: '#1976d2' }}
                    >
                      📎 دانلود فایل
                    </a>
                  ) : Array.isArray(value) ? (
                    <ul style={{ paddingRight: 20 }}>
                      {value.map((v, i) => (
                        <li key={i}>{v}</li>
                      ))}
                    </ul>
                  ) : typeof value === 'object' && value !== null ? (
                    <pre style={{ background: '#f5f5f5', padding: 8, borderRadius: 4 }}>
                      {JSON.stringify(value, null, 2)}
                    </pre>
                  ) : (
                    <Typography>{value ?? '—'}</Typography>
                  )}
                </Box>
              );
            })
          ) : (
            <Typography color="text.secondary">
              ساختار فرم یافت نشد.
            </Typography>
          )}

          <Stack direction="row" justifyContent="flex-end" mt={2}>
            <Button variant="outlined" onClick={() => { setSelected(null); setStructure([]); }}>
              بستن
            </Button>
          </Stack>
        </Box>
      )}
    </Box>
  );
};

export default SubjectResponsesPage;
